function triggerHotjar (recordingName) {
  if (typeof window === 'undefined') return

  if (typeof window.hj === 'function') {
    window.hj('trigger', recordingName)
  }
}

function recordExperiment ({ experimentKey, variationKey, path }) {
  if (typeof window === 'undefined') return

  if (!experimentKey || !variationKey || !path) {
    return null
  }

  const recordingName = `${experimentKey}-${variationKey}-${path.replace(/[\s/]/g, '_')}`

  if (window) {
    window.addEventListener('CookiebotOnAccept', () => triggerHotjar(recordingName))
    window.addEventListener('CookiebotOnLoad', () => triggerHotjar(recordingName))

    if (window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.statistics) {
      triggerHotjar(recordingName)

      window.removeEventListener('CookiebotOnAccept', () => triggerHotjar(recordingName))
      window.removeEventListener('CookiebotOnLoad', () => triggerHotjar(recordingName))
    }
  }

  return recordingName
}

module.exports = {
  recordExperiment
}
